export default "__VITE_ASSET__BVH_lWnQ__"